import type { DependencyList } from 'react';
import { useEffect, useState } from 'react';

export function useAsyncMemo<T>(
  callback: () => Promise<T>,
  deps: DependencyList
) {
  const [value, setValue] = useState<T>();
  useEffect(() => {
    let cancel = false;

    callback().then((val) => {
      if (!cancel) {
        setValue(val);
      }
    });

    return () => {
      cancel = true;
    };
  }, deps);

  return value;
}
